var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1687 2.57229C21.3374 2.98795 20.506 3.12651 19.5361 3.26506C20.506 2.71084 21.1988 1.87952 21.4759 0.771083C20.6446 1.3253 19.6747 1.60241 18.5663 1.87952C17.7349 1.04819 16.488 0.493975 15.241 0.493975C12.3313 0.493975 10.1145 3.26506 10.8072 6.03614C7.06627 5.89759 3.74096 4.09639 1.38554 1.3253C0.138554 3.40361 0.831325 6.03614 2.77108 7.42169C2.07831 7.42169 1.38554 7.14458 0.692771 6.86747C0.692771 8.94578 2.21687 10.8855 4.29518 11.4398C3.60241 11.5783 2.90964 11.7169 2.21687 11.5783C2.77109 13.3795 4.43373 14.7651 6.51205 14.7651C4.8494 16.012 2.35542 16.7048 0 16.4277C2.07831 17.6747 4.43374 18.506 6.92771 18.506C15.3795 18.506 20.0904 11.4398 19.8133 4.92771C20.7831 4.37349 21.6145 3.54217 22.1687 2.57229Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7f4383953e32c30b541fed0ec82c27da.svg";
export { ForwardRef as ReactComponent };